import Api from "@/services/api";
import {
  Product,
  ProductToRemove,
  RemoveProductPayload,
  UpdateQuantityPayload,
  ProductToAdd,
  AddProductPayload,
  ProductToUpdate
} from "./checkout.types";

export async function createNewCart() {
  try {
    const { data } = await Api.post("/checkout/cart");
    return data;
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
}

export async function getCart(cartId: string) {
  try {
    const { data } = await Api.get(`/checkout/cart/${cartId}`);
    return data;
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
}

export async function removeProduct(
  product: Product,
  orderFormId: string
): Promise<any> {
  const productToRemove: ProductToRemove = {
    seller: product.seller,
    quantity: 0,
    id: product.id,
    index: product.index
  };
  const payload: RemoveProductPayload = { orderItems: [productToRemove] };

  try {
    const { data } = await Api.patch(
      `/checkout/cart/${orderFormId}/items`,
      payload
    );
    return data;
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
}

export async function updateQuantity(
  products: ProductToUpdate[],
  orderFormId: string
): Promise<any> {
  const productToUpdate = products.map(({ quantity, product }) => ({
    quantity,
    seller: product.seller,
    id: product.id,
    index: product.index
  }));

  const payload: UpdateQuantityPayload = {
    orderItems: productToUpdate,
    noSplitItem: false
  };

  try {
    const { data } = await Api.patch(
      `/checkout/cart/${orderFormId}/items`,
      payload
    );

    return data;
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
}

export async function addProduct(
  orderFormId: string,
  products: ProductToAdd[]
): Promise<any> {
  const orderItems = products.map((product) => ({
    seller: product?.seller || "1",
    quantity: product?.quantity || 1,
    id: product.id
  }));
  const requestPayload: AddProductPayload = { orderItems };

  try {
    const { data } = await Api.post(
      `/checkout/cart/${orderFormId}/items`,
      requestPayload
    );
    return data;
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
}

export const clearMessages = async (
  orderFormId: string
): Promise<{ success: boolean; message?: string }> => {
  try {
    const { data }: { data: { success: boolean; message?: string } } =
      await Api.delete(`/checkout/cart/${orderFormId}/messages`);
    return data;
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};
